module.exports = __webpack_public_path__ + "static/media/resetIcon.d6c46abe.svg";